import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getAnalytics, logEvent } from "firebase/analytics";

const getPageTitle = (pathname: string): string => {
  switch (pathname) {
    case "/":
      return "Public株式会社";
    case "/check/terms":
      return "利用規約 | CHECK";
    case "/check/privacy":
      return "プライバシーポリシー | CHECK";
    case "/check/tokushoho":
      return "特定商取引法に基づく表記 | CHECK";
    default:
      return "Public, Inc - パブリック株式会社";
  }
};

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    const analytics = getAnalytics();
    const pageTitle = getPageTitle(location.pathname);
    document.title = pageTitle;

    logEvent(analytics, "page_view", {
      page_path: location.pathname,
      page_title: pageTitle,
    });
  }, [location]);
};
